import { useTheme } from '@mui/material'
import { Breakpoint } from '@mui/system'
import React from 'react'

import { AdaptiveValue } from '../System/styledUtils'

export interface PictureProps {
	width?: React.CSSProperties['width']
	srcSets?: AdaptiveValue<string>
	defaultSrc: string
	alt?: string
}

export function Picture({ width, srcSets = {}, defaultSrc, alt }: PictureProps) {
	const theme = useTheme()

	return (
		<picture>
			{Object.keys(srcSets).map((key: Breakpoint) => {
				// @ts-expect-error todo if you see this please remove this comment and fix the type error
				return <source srcSet={srcSets[key]} key={key} media={theme.breakpoints.down(key).replace('@media ', '')} />
			})}
			<source srcSet={defaultSrc} />
			<img src={defaultSrc} alt={alt} width={width} />
		</picture>
	)
}
